import React, { useState, useEffect, useRef } from "react";
import Cookies from "js-cookie";
import moment from "moment";
import Pagination from "../../Common/Pagination/Pagination";
import CountUp from "react-countup";
import { useReactToPrint } from "react-to-print";
import _ from "lodash";
const PrivateSupplyStatus = ({ selectedDate, companyDetails }) => {
  const SERVER_URL = process.env.REACT_APP_SERVER_URL;
  const user_id = Cookies.get("users_id")?.replace(/"/g, "");
  const token = Cookies.get("token")?.replace(/"/g, "");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [status, setStatus] = useState("true");
  const [pageSize, setPageSize] = useState(10);
  const [statusOrder, setStatusOrder] = useState([]);
  const totalPages = Math.ceil(totalRecords / pageSize);
  const startItem = (currentPage - 1) * pageSize + 1;
  const endItem = Math?.min(startItem + statusOrder?.length - 1, totalRecords);
  const [companyId, setCompanyId] = useState("");
  const [privateCountData, setPrivateCountData] = useState([]);

  const [filterCriteria, setfilterCriteria] = useState({
    party_name: "",
  });

  const handleFilterChange = (name, value) => {
    setfilterCriteria(() => {
      return {
        ...filterCriteria,
        [name]: value,
      };
    });
  };

  const componentPDF = useRef();
  const generatePDF = useReactToPrint({
    content: () => componentPDF.current,
    pageStyle: `
      @page {
        size: auto !important;
      }
      @media print {
        table {
          width: 100%;
          border-collapse: collapse;
          border: 1px solid #ddd;
          border-spacing: 0;
          margin-bottom: 10px;
          transform: scale(0.9);
        }
        th, td {
          border: 1px solid #ddd;
          padding: 8px;
        }
      }`,
    documentTitle: "Private Order Status",
  });
  const getPrivateOrderCount = async () => {
    const renewalDate = moment(selectedDate).format("YYYY-MM-DD");
    let BASE_URL =
      SERVER_URL +
      `/api/dispatch-status/private-dispatch-status-count/${user_id}?date=${renewalDate}&companyId=${companyId}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    if (res.ok) {
      setPrivateCountData(result.data);
    } else {
      setPrivateCountData([]);
    }
  };
  useEffect(() => {
    getPrivateOrderCount();
  }, [companyId, selectedDate]);
  const getOrderStatusData = async () => {
    const currentQueryDate = moment(selectedDate).format("YYYY-MM-DD");
    const BASE_URL = `${SERVER_URL}/api/dispatch-status/private-dispatch-status-report/${user_id}?date=${currentQueryDate}&companyId=${companyId}&take=${pageSize}&skip=${
      currentPage - 1
    }&party_name=${filterCriteria.party_name}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    if (res.ok) {
      setTotalRecords(result.total);
      setStatusOrder(result.data);
    } else {
      setStatusOrder([]);
    }
  };

  const onPageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  const onPageSizeChange = (event) => {
    setPageSize(parseInt(event.target.value));
    setCurrentPage(1); // Reset to the first page when page size changes
  };

  const handleCompanyChange = (e) => {
    setCompanyId(e.target.value);
  };

  useEffect(() => {
    const fecthDebounced = _.debounce(getOrderStatusData, 500);
    fecthDebounced();
    return () => {
      fecthDebounced.cancel();
    };
  }, [currentPage, pageSize, selectedDate, companyId, filterCriteria]);
  return (
    <>
      <div className="card mt-4">
        <div className="card-body">
          <div>
            <div
              style={{
                justifyContent: "space-between",
                display: "flex",
              }}
            >
              <p className="card-title">Private Orders Supply Details</p>
              <div style={{ display: "flex" }}>
                <select
                  className="form-control ml-2"
                  onChange={handleCompanyChange}
                  value={companyId}
                >
                  <option value="">Select Company (All)</option>
                  {companyDetails &&
                    companyDetails?.length > 0 &&
                    companyDetails?.map((item, id) => {
                      return (
                        <option
                          key={id}
                          value={item.id}
                        >{`${item.companyName}, ${item.location}`}</option>
                      );
                    })}
                </select>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="d-flex border-md-right flex-grow-1  p-3 item justify-content-center">
                  <i
                    className={`mdi mdi-truck-fast menu-icon mr-4 icon-lg dashboard-icon`}
                  ></i>
                  <div className="d-flex flex-column justify-content-around">
                    <small className="mb-1 text-muted">Total Orders</small>
                    <h2>
                      <CountUp
                        end={privateCountData?.activeCount}
                        duration={2}
                        separator=","
                      />
                    </h2>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="card mt-4">
        <div className="card-body">
          <div className="status_heading">
            <h5>
              Private Supply Status As On Date:{" "}
              {moment(selectedDate).format("DD-MM-YYYY")}
            </h5>
          </div>

          <div className="row">
            <div className="col-md-6 d-flex flex-wrap">
              <div className="col-md-6">
                <div className="form-group flex-grow-1 me-2">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search by party name"
                    id="party_name"
                    name="party_name"
                    onChange={(e) =>
                      handleFilterChange("party_name", e.target.value)
                    }
                    autoComplete="off"
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <p>
                <span className="print_btn d-flex justify-content-end">
                  <i
                    className="mdi mdi-printer-eye"
                    style={{ fontSize: "25px" }}
                    onClick={() =>
                      statusOrder && statusOrder?.length > 0
                        ? generatePDF()
                        : null
                    }
                  ></i>
                </span>
              </p>
            </div>
          </div>

          <div className="tkcs-table-container">
            <div
              className="table-responsive table-bordered govt-table"
              style={{
                border: "0.05px solid lightGray",
                width: "auto",
                marginTop: "20px",
              }}
              ref={componentPDF}
            >
              <table className="table">
                <thead>
                  <tr>
                    <th rowSpan={2}>S.NO</th>
                    <th rowSpan={2}>Product Name</th>
                    <th rowSpan={2}>Company Name</th>
                    <th rowSpan={2}>Party Name</th>
                    <th rowSpan={2}>Invoice Qty</th>
                    <th colSpan={5}>Dispatch Details</th>
                    <th rowSpan={2}>Dispatch Qty</th>
                    <th rowSpan={2}>Dispatch Balance</th>
                    <th rowSpan={2}>Dispatch Date</th>
                    <th rowSpan={2}>GP Number</th>
                    <th rowSpan={2}>Invoice Date</th>
                    <th rowSpan={2}>Invoice Number</th>
                    <th rowSpan={2}>Vehicle Number</th>
                    <th rowSpan={2}>Remarks</th>
                  </tr>
                  <tr>
                    <th>Yard Name</th>
                    <th>Company Name</th>
                    <th>Dispatch Qty</th>
                    <th>Opening Stock</th>
                    <th>Closing Stock</th>
                  </tr>
                </thead>
                <tbody>
                  {statusOrder?.map((detail, detailIndex) => (
                    <React.Fragment key={detailIndex}>
                      {detail.dispatch_details.map(
                        (orderDetail, orderIndex) => {
                          const dispatchLen = detail.dispatch_details.length;
                          return (
                            <tr key={orderIndex}>
                              {orderIndex === 0 && (
                                <>
                                  <td rowSpan={dispatchLen}>
                                    {detailIndex + 1}
                                  </td>
                                  <td rowSpan={dispatchLen}>
                                    {detail.product_name}
                                  </td>
                                  <td rowSpan={dispatchLen}>
                                    {detail.company_name}
                                  </td>
                                  <td rowSpan={dispatchLen}>
                                    {detail.party_name}
                                  </td>
                                  <td rowSpan={dispatchLen}>
                                    {detail.invoice_qty}
                                  </td>
                                </>
                              )}
                              <td>{orderDetail.yard_name}</td>
                              <td>{orderDetail.company_name}</td>
                              <td>{orderDetail.dispatch_qty}</td>
                              <td>{orderDetail.p_opening_stock}</td>
                              <td>{orderDetail.p_closing_stock}</td>
                              {orderIndex === 0 && (
                                <>
                                  <td rowSpan={dispatchLen}>
                                    {detail.total_dispatch_qty}
                                  </td>
                                  <td rowSpan={dispatchLen}>
                                    {detail.dispatch_balance}
                                  </td>
                                  <td rowSpan={dispatchLen}>
                                    {detail.dispatch_date}
                                  </td>
                                  <td rowSpan={dispatchLen}>
                                    {detail.gp_number}
                                  </td>
                                  <td rowSpan={dispatchLen}>
                                    {detail.invoice_date}
                                  </td>
                                  <td rowSpan={dispatchLen}>
                                    {detail.invoice_number}
                                  </td>
                                  <td rowSpan={dispatchLen}>
                                    {detail.vehicle_number}
                                  </td>
                                  <td rowSpan={dispatchLen}>
                                    {detail.remarks ? detail.remarks : "-"}
                                  </td>
                                </>
                              )}
                            </tr>
                          );
                        }
                      )}
                    </React.Fragment>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <Pagination
          currentPage={currentPage}
          totalRecords={totalRecords}
          pageSize={pageSize}
          totalPages={totalPages}
          startItem={startItem}
          endItem={endItem}
          onPageChange={onPageChange}
          onPageSizeChange={onPageSizeChange}
        />
      </div>
    </>
  );
};

export default PrivateSupplyStatus;
